module.exports = __webpack_public_path__ + "static/media/junk-is-no-good-baby.f7e76e18.txt";